import Vue from 'vue'
import VueRouter from 'vue-router'
import { syncState } from '@/services/syncService';
import appContent from '@/components/content'
import info from '@/views/info'

import main from '@/views/home'
import stok_detay from '@/views/stok/detay'
import search from '@/views/stok/atilgan'
//import search from '@/views/stok/arama'
import yeni from '@/views/stok/yeni'
import iade from '@/views/stok/iade'
import stokYetki from '@/views/stok/yetki'



import cari from '@/views/cari/dashboard'
import cari_list from '@/views/cari/list'
import cari_extre from '@/views/cari/extre'
import sepet from '@/views/cari/sepet'

// import caridetay from '@/views/caridetay'
// import hareket from '@/views/hareket'
//import ekstredetay from '@/views/ekstredetay'

import kullanici_list from '@/views/kullanici/list'
import kullanici_yetki from '@/views/kullanici/yetki'


import siparis_list from '@/views/siparis/list'
import siparis_detay from '@/views/siparis/detay'
import siparis_add from '@/views/siparis/add'
import siparis_tahsilat_sonuc from '@/views/siparis/tahsilat_sonuc'
import siparis_sonuc from '@/views/siparis/sonuc'

import plan from '@/views/plan'


import teklif_add from '@/views/teklif/add'
import teklif_list from '@/views/teklif/list'
import teklif_detay from '@/views/teklif/detay'

import tahsilat_add from '@/views/tahsilat/add'
import tahsilat_sonuc from '@/views/tahsilat/sonuc'
import tahsilat_list from '@/views/tahsilat/list'


import hesap from '@/views/hesap'

//
import login from '@/views/login'
import oturum from '@/views/oturum'
import uretim from '@/views/uretim'
import ziyaret from '@/views/ziyaret'
import liste from '@/views/liste'
import sonuc from '@/views/sonuc'

import test from '@/views/test'






Vue.use(VueRouter)
// var tfx = JSON.parse(localStorage.getItem("tfx"))
// let firma = "";
// if (tfx != null) {
//   tfx =
//     firma = tfx.firma.isim
// }
const routes = [
  { path: '/login', component: login },
  { path: "/oturum", name: "OTURUM", component: oturum },
  {
    path: "/test",
    name: "test",
    component: test,
  },
  {
    path: '/',
    component: appContent,
    redirect: '/',
    children: [

      {
        path: "/",
        name: "Öne Çıkan Ürünler",
        component: main,
      },
      {
        path: "/planlama/list",
        name: "ZİYARET LİSTESİ",
        component: plan,
      },
      {
        path: "/info",
        name: "YETKİSİZ ALAN",
        component: info,
      },
      {
        path: '/stok/detay',
        name: 'Stok Detay',
        component: stok_detay
      },
      // ----------------
      {
        path: '/teklif/add',
        name: 'YENİ TEKLİF',
        component: teklif_add,
      },
      {
        path: '/teklif/list',
        name: 'TEKLİF LİSTESİ',
        component: teklif_list,
      },
      {
        path: '/teklif/:seri',
        name: 'TEKLİF DETAY',
        component: teklif_detay,
      },

      // ----------------

      // ----------------
      {
        path: '/kullanici/list',
        name: 'KULLANICI LİSTE',
        component: kullanici_list,
      },
      {
        path: '/kullanici/yetki',
        name: 'Cari Yetki Al-Ver',
        component: kullanici_yetki,
      },
      // ----------------

      // ----------------
      {
        path: '/stok/yeni',
        name: 'Yeni Ürünler',
        component: yeni
      }, {
        path: '/search',
        name: 'Ürünler',
        component: search
      },
      {
        path: '/stok/iade',
        name: 'İptal - İade',
        component: iade
      },
      {
        path: '/stok/yetki/:alan',
        name: 'Stok Yetki Al-Ver ',
        component: stokYetki
      },
      {
        path: '/cari',
        name: 'MÜŞTERİ DASHBOARD',
        component: cari,
      },
      {
        path: '/cari/list',
        name: 'MÜŞTERİ LİSTE',
        component: cari_list,
      },

      {
        path: '/cari/sepet',
        name: 'MÜŞTERİ SEPET',
        component: sepet
      },


      {
        path: '/cari/extre',
        name: 'MÜŞTERİ EXTRE',
        component: cari_extre
      },
      // ---------------
      {
        path: '/liste',
        name: 'LİSTE',
        component: liste
      },
      {
        path: '/sonuc',
        name: 'SİPARİŞ',
        component: sonuc
      },
      {
        path: '/siparis/list',
        name: 'SİPARİŞLER',
        component: siparis_list
      },
      {
        path: '/siparis/add',
        name: 'SİPARİŞ EKLE',
        component: siparis_add
      },
      {
        path: '/siparis/tahsilat_sonuc',
        name: 'SIPARIS TAHSILAT SONUC',
        component: siparis_tahsilat_sonuc
      },
      {
        path: '/siparis/sonuc',
        name: 'SIPARIS SONUC',
        component: siparis_sonuc
      },
      {
        path: '/siparis/:seri',
        name: 'SİPARİŞ DETAY',
        component: siparis_detay
      },
      {
        path: '/cari/ziyaret',
        name: 'ZİYARET',
        component: ziyaret
      },
      {
        path: '/tahsilat/add',
        name: 'YENİ TAHSİLAT',
        component: tahsilat_add
      },
      {
        path: '/tahsilat/sonuc',
        name: 'TAHSİLAT SONUC',
        component: tahsilat_sonuc
      },
      {
        path: '/tahsilat/liste',
        name: 'TAHSİLATLAR',
        component: tahsilat_list
      },
      {
        path: '/uretim',
        name: 'ÜRETİM',
        component: uretim
      },

      {
        path: '/hesap',
        name: 'HESABIM',
        component: hesap
      }
    ]
  }
];
export const router = new VueRouter({
  //mode: "history",
  routes
});
router.beforeEach((to, from, next) => {
  // 1) Sync kilidi: kritik işlemlerde route değişimini engelle
  // Login'e izin verelim (opsiyonel)
  if (syncState.locked) {
    if (to.path === '/login') return next();
    return next(false);
  }

  // 2) Public sayfalar
  const publicPages = ['/login'];

  // to.path yerine matched ile daha doğru kontrol (nested route'larda)
  const isPublic = publicPages.includes(to.path);
  const authRequired = !isPublic;

  // 3) Auth kontrol
  let loggedIn = false;
  try {
    const tfxm = localStorage.getItem('tfxm');
    loggedIn = !!(tfxm && JSON.parse(tfxm));
  } catch (e) {
    loggedIn = false;
  }

  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { returnUrl: to.fullPath }
    });
  }

  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js